//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Unit_conversion_of_common_ions',
  data () {
    return {
      form: {
        input: '',
        input1: '',
        input2: '',
        input3: '',
        input4: '',
        input5: '',
        input6: '',
        input7: '',
        input8: ''
      },
      hasScore: false,
      disabled: false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form['input'] == '---') {
        flag = false
      } else {
        form['input'] = Number(form['input'])
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
        let result = form.input
        self.hasScore = true
        return String(result.toFixed(5))
      }
    },
    score1 () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form['input1'] == '---') {
        flag = false
      } else {
        form['input1'] = Number(form['input1'])
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
        let result = form.input1
        self.hasScore = true
        return String(result.toFixed(5))
      }
    },
    score2 () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form['input2'] == '---') {
        flag = false
      } else {
        form['input2'] = Number(form['input2'])
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
        let result = form.input2
        self.hasScore = true
        return String(result.toFixed(5))
      }
    },
    score3 () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form['input3'] == '---') {
        flag = false
      } else {
        form['input3'] = Number(form['input3'])
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
        let result = form.input3
        self.hasScore = true
        return String(result.toFixed(5))
      }
    },
    score4 () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form['input4'] == '---') {
        flag = false
      } else {
        form['input4'] = Number(form['input4'])
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
        let result = form.input4
        self.hasScore = true
        return String(result.toFixed(5))
      }
    },
    score5 () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form['input5'] == '---') {
        flag = false
      } else {
        form['input5'] = Number(form['input5'])
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
        let result = form.input5
        self.hasScore = true
        return String(result.toFixed(5))
      }
    },
    score6 () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form['input6'] == '---') {
        flag = false
      } else {
        form['input6'] = Number(form['input6'])
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
        let result = form.input6
        self.hasScore = true
        return String(result.toFixed(5))
      }
    },
    score7 () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form['input7'] == '---') {
        flag = false
      } else {
        form['input7'] = Number(form['input7'])
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
        let result = form.input7
        self.hasScore = true
        return String(result.toFixed(5))
      }
    },
    score8 () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form['input8'] == '---') {
        flag = false
      } else {
        form['input8'] = Number(form['input8'])
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
        let result = form.input8
        self.hasScore = true
        return String(result.toFixed(5))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Unit_conversion_of_common_ions.vue